export default __webpack_public_path__ + "static/media/3columns.a8ae4285.svg";